import r from "./_root.js";
var t = r.Uint8Array;
const o = t;
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_Uint8Array.js
// module id = 859
// module chunks = 41